import { Helmet } from "react-helmet"
import { useQuery } from "@apollo/client"
import orderBy from "lodash/orderBy"
import partition from "lodash/partition"
import isEmpty from "lodash/isEmpty"
import { DateTime } from "luxon"

import Nav from "components/shared/Nav"
import FullPageLoader from "components/shared/FullPageLoader"
import ErrorToast from "components/shared/ErrorToast"
import {
  useForceAuthEffect,
  useLoginState,
  useVerificationRedirectEffect
} from "components/Login/hooks"
import SessionCard from "./SessionCard"
import { RsvpPortalParkingSessions } from "./operations"

import styles from "./ParkingSessions.module.scss"

const ParkingSessions = () => {
  useForceAuthEffect({ authUrl: "/login" })
  useVerificationRedirectEffect()
  const [isLoggedIn] = useLoginState()
  const { loading, data } = useQuery(RsvpPortalParkingSessions, {
    variables: { rsvpPortalId: process.env.REACT_APP_RSVP_PORTAL_ID },
    skip: !isLoggedIn
  })

  if (!isLoggedIn || loading)
    return <FullPageLoader message="Loading parking reservations" />

  const { rsvpPortalParkingSessions } = data

  const partitionedSessions = partition(
    rsvpPortalParkingSessions,
    (session) =>
      DateTime.fromISO(session.endTime) >= DateTime.now() && !session.voided
  )

  const activeSessions = orderBy(partitionedSessions[0], ["startTime"], ["asc"])
  const oldSessions = orderBy(partitionedSessions[1], ["startTime"], ["desc"])

  return (
    <div className="d-flex flex-column h-100">
      <Helmet>
        <title>Parking Sessions</title>
      </Helmet>
      <Nav />

      <div className="container-sm">
        <div className="row justify-content-center">
          <div className="col-md-8 col-xl-6">
            <h2 className={styles.title}>Parking Sessions</h2>
            <div className={styles.content}>
              {!isEmpty(activeSessions) && (
                <div className="mb-5">
                  <h5 className={styles.subTitle}>Active Sessions</h5>
                  {activeSessions.map((session) => (
                    <SessionCard session={session} key={session.hashid} />
                  ))}
                </div>
              )}
              {!isEmpty(oldSessions) && (
                <>
                  <h5 className={styles.subTitle}>Previous Sessions</h5>
                  {oldSessions.map((session) => (
                    <SessionCard session={session} key={session.hashid} />
                  ))}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <ErrorToast />
    </div>
  )
}

export default ParkingSessions
